<template>
  <div class="row no-gutters" style="font-size:0.6em;background:none;background-color:#f5f5f5;max-height:250px;overflow:scroll;">
    <table class="table table-striped table-sm" style="margin-bottom:6px;">
      <thead>
        <tr>
            <th scope="col">Color</th>
            <th scope="col" class='text-center'>Area</th>
            <th scope="col">Aridity</th>
            <th scope="col">Land Cover</th>
            <th scope="col" class="text-center">Slope</th>
            <th scope="col">Soil</th>
            <th></th>
        </tr>
      </thead>
      <tbody>

        <tr v-for="row in extendedlegend.values">
            <td><div :style="colorStyle(row['HEX'])"></div>
            <td class='text-center'>{{ percentStyle(row['percent']) }}</td>
            <td>{{ row['AI zone'] }}</td>
            <td>{{ row['Land cover'] }}</td>
            <td class="text-center">{{ row['Slope (%)'] }}</td>
            <td>{{ row['Soil'] }}</td>
            <td class="text-right" ><!--<a @click.prevent="setSideBar(row['Code'])" href="#" style="margin-right:5px;"><nobr>More information</nobr></a>--></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import _ from 'lodash';


export default {
    name: 'RasterMapExtendedLegend',
    components: { },
    props: ['extendedlegend'],
    data() {
      return {};
    },
    computed: {

    },
    methods: {
      colorStyle(color) {
        return "min-width:30px;width:100%;height:22px;border:1px solid rgba(0,0,0,0.3);background-color:"+color;
      },
      percentStyle(percent) {
        return percent.toFixed(1)+"%"
      },
      headerLabel(header) {
        if(header=='color') {
          return '';
        }
        return header
      },
      setSideBar(item) {
        this.$emit('set-sidebar', item)
      }
    }
}
</script>

<style scoped>
div.histogram {
  color:#000;margin:0px 0px;height:50px;width:100%;display:flex;
}
div.labels {
  display:block;
  position:relative;
  color:#000;
  top:-20px;
  width:100%;
  height:35px;
}
div.colormap {
  display:block;color:#000;position:relative;top:0px;width:100%;
}
</style>